export enum LiveDealerViewEnum {
  LIVE_DEALER_ONLY = 1,
  LIVE_DEALER_AND_CASINO = 2,
  CASINO_ONLY = 3,
  ERROR_LIVE_DEALER_VIEW = 4,
}
